import type { SelectProps } from '@ksyos/design-system/dist/components/select';
import type { Props as ReactSelectProps } from 'react-select';
import { FormGroup, Select } from '@ksyos/design-system';
import { getValidationErrorTranslation } from '@frontend/utils/index';
import type { FormContextProps } from '../elements/formContext';
import type { IOption } from '../interfaces';
import type { OmittedFormGroupFieldProps } from './FormGroup';
import { FormContextConsumer } from '../elements/formContext';
import { computeFormGroupProps } from './FormGroup';

type PickedReactSelectProps = Pick<
    ReactSelectProps,
    'backspaceRemovesValue' | 'className' | 'isClearable' | 'onChange' | 'options' | 'placeholder' | 'value'
>;

interface SelectFieldProps extends SelectProps {
    className?: string;
    isClearable?: boolean;
    onChange: (value: string | null) => Promise<void> | void;
    onDoValidate?: () => void;
    options: IOption<string>[];
    placeholder?: string;
    units?: string;
    value: string | null;
}

export function computeSelectProps(properties: SelectFieldProps): PickedReactSelectProps & SelectProps {
    return {
        backspaceRemovesValue: true,
        className: properties.className,
        error: properties.error,
        isClearable: properties.isClearable ?? true,
        onChange: async (option: any) => {
            await properties.onChange(option?.value ?? null);
            properties.onDoValidate?.();
        },
        options: properties.options,
        placeholder: properties.placeholder,
        size: properties.size,
        value: properties.options?.find((option) => option.value === properties.value) ?? null,
    };
}

export type SelectFormGroupFieldProps = OmittedFormGroupFieldProps & SelectFieldProps;

export type SelectCountryFormGroupFieldProps = OmittedFormGroupFieldProps & Omit<SelectFieldProps, 'options'>;

export function SelectFormGroupField(props: FormContextProps<SelectFormGroupFieldProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => {
                return (
                    <FormGroup {...computeFormGroupProps(properties)}>
                        <Select
                            {...computeSelectProps(properties)}
                            error={getValidationErrorTranslation(properties.error)}
                        />
                    </FormGroup>
                );
            }}
        </FormContextConsumer>
    );
}
